var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgErrorModal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 750,
    height: 612,
    viewBox: "0 0 750 612",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "No Internet"
  }, /*#__PURE__*/React.createElement("g", {
    id: "circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 1",
    d: "M27.238 281.082V287.415",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 2",
    d: "M13.0173 284.512L18.1924 289.839",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 4",
    d: "M6.9646 298.695H14.2821",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 6",
    d: "M12.4248 313.129L17.5999 307.802",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 9",
    d: "M27.238 314.857V308.524",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 10",
    d: "M37.7941 310.635L33.572 306.413",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 11",
    d: "M46.2333 300.079H39.9001",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 12",
    d: "M42.0128 285.302L37.7908 289.524",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 13",
    d: "M367.111 4.53369V8.75576",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 15",
    d: "M354.449 17.2002H358.671",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 16",
    d: "M367.111 29.8671V25.645",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 17",
    d: "M377.673 17.2002H373.451",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 18",
    d: "M122.236 181.86V188.193",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 19",
    d: "M103.24 200.861H109.573",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 20",
    d: "M122.236 217.75V211.417",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 21",
    d: "M139.128 200.861H132.795",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 42"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 22",
    d: "M576.644 412.05C581.689 412.05 585.781 416.143 585.781 421.189C585.781 426.237 581.689 430.328 576.644 430.328C571.599 430.328 567.508 426.237 567.508 421.189",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 24",
    d: "M618.347 532.187C619.476 540.068 614.007 547.371 606.13 548.5C598.252 549.628 590.95 544.157 589.821 536.278C588.692 528.399 594.162 521.096 602.039 519.967",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 26",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M618.461 329.137C623.886 327.444 632.201 320.81 634.126 313.671C635.872 319.982 643.189 327.444 649.792 328.009C642.359 330.641 635.253 338.458 634.126 344.6C633.359 338.34 623.531 330.049 618.461 329.137Z",
    fill: "#EBECEE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 28",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.5923 409.234C64.3056 408.388 68.4617 405.071 69.4241 401.502C70.2969 404.655 73.9548 408.388 77.256 408.671C73.5408 409.985 69.9887 413.895 69.4241 416.965C69.0406 413.835 64.1264 409.689 61.5923 409.234Z",
    fill: "#EBECEE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 30",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.942 115.571C111.942 119.486 108.77 122.658 104.858 122.658C100.944 122.658 97.7732 119.486 97.7732 115.571C97.7732 111.658 100.944 108.485 104.858 108.485C108.77 108.485 111.942 111.658 111.942 115.571Z",
    fill: "#D1D8DF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 32",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M530.312 560.495C530.312 567.037 525.009 572.339 518.471 572.339C511.93 572.339 506.629 567.037 506.629 560.495C506.629 553.954 511.93 548.651 518.471 548.651C525.009 548.651 530.312 553.954 530.312 560.495Z",
    fill: "#EBECEE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 34",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M749.036 102.51C749.036 107.699 744.831 111.905 739.645 111.905C734.456 111.905 730.252 107.699 730.252 102.51C730.252 97.3198 734.456 93.1143 739.645 93.1143C744.831 93.1143 749.036 97.3198 749.036 102.51Z",
    fill: "#EBECEE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 36",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M244.344 541.304C244.344 544.576 241.693 547.227 238.423 547.227C235.154 547.227 232.503 544.576 232.503 541.304C232.503 538.033 235.154 535.381 238.423 535.381C241.693 535.381 244.344 538.033 244.344 541.304Z",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 38",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.825 70.0453C240.825 73.9605 237.653 77.1317 233.74 77.1317C229.828 77.1317 226.656 73.9605 226.656 70.0453C226.656 66.132 229.828 62.959 233.74 62.959C237.653 62.959 240.825 66.132 240.825 70.0453Z",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 40",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M421.537 606.892C417.009 608.615 411.943 606.34 410.221 601.814C408.498 597.285 410.771 592.216 415.3 590.495C419.825 588.772 424.891 591.045 426.614 595.573C428.338 600.102 426.064 605.169 421.537 606.892Z",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M297.449 460.423H337.939L316.729 527.906L411.208 432.466H354.327L386.142 292.676L297.449 460.423Z",
    fill: "url(#paint0_linear_2432_3338)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M539.658 250.256C529.675 243.163 518.02 238.274 505.39 236.323C498.481 175.963 447.239 129.085 385.029 129.085C346.262 129.085 311.755 147.299 289.572 175.635C281.789 173.028 273.48 171.605 264.816 171.605C225.04 171.605 192.239 201.422 187.504 239.921C154.586 250.125 130.685 280.814 130.685 317.077C130.685 361.556 166.636 397.628 211.074 397.837C213.362 398.145 215.688 398.324 218.061 398.324H482.188C487.064 399.238 492.067 399.737 497.208 399.737C541.822 399.737 577.976 363.577 577.976 318.968C577.976 289.933 562.652 264.489 539.658 250.256Z",
    fill: "#F1F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M315.122 204.507C305.775 200.714 295.373 198.584 284.409 198.584C243.805 198.584 210.9 227.568 210.9 263.314C210.9 266.929 211.245 270.469 211.895 273.917C243.465 229.32 265.219 211.609 315.122 204.507Z",
    fill: "#E0E2EE"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2432_3338",
    x1: 354.329,
    y1: 175.06,
    x2: 169.935,
    y2: 264.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8960"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF62A5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorModal);
export default __webpack_public_path__ + "static/media/ErrorModal.4e72c9871505ca76db49fa01b6260a5f.svg";
export { ForwardRef as ReactComponent };